<template>
  <v-autocomplete
    :id="id"
    v-model="localValue"
    menu-icon="mdi-chevron-down"
    class="select-base"
    density="compact"
    hide-details="auto"
    variant="solo"
    hide-no-data
    :class="computedClasses"
    :clearable="clearable"
    :disabled="disabled"
    :item-title="itemText"
    :item-value="itemValue"
    :items="items"
    :label="label"
    :placeholder="placeholderVal"
    :rules="rules"
  >
    <template #item="{ item, index, props }">
      <v-list-item v-bind="props" :id="'id' + index" class="item-list" :disabled="item.disabled">
        <v-list-item-title v-if="getItemText(item)">
          <v-tooltip v-if="getItemText(item).length > truncateAt" location="bottom" :max-width="250">
            <template #activator="tooltip">
              <span v-bind="tooltip.props">
                {{ truncateText(getItemText(item), truncateAt) }}
              </span>
            </template>
            {{ getItemText(item) }}
          </v-tooltip>
          <span v-else> {{ getItemText(item) }}</span>
        </v-list-item-title>

        <v-list-item-subtitle v-if="item.itemSubtitle" class="select-item-subtitle">
          {{ item.itemSubtitle }}
        </v-list-item-subtitle>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import UtilsString from '@/utils/UtilsString';
import { uniqueId } from 'lodash';

export default {
  emits: ['update:modelValue'],
  props: {
    id: {
      type: String,
      default: uniqueId('_select_simple'),
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      required: true,
      default: 'Select',
    },

    items: {
      type: Array,
      required: false,
      default: () => {
        return [{}];
      },
    },

    placeholder: {
      required: false,
      default: 'Selecione uma opção',
    },

    modelValue: {
      type: [Boolean, String, Number, Array, Object],
      default: null,
    },

    itemValue: {
      type: [String, Function],
      default: 'itemId',
    },

    itemText: {
      type: [String, Function],
      default: 'itemTitle',
    },

    rules: {
      type: Array,
      default: () => [],
    },

    truncateAt: {
      type: Number,
      default: 28,
    },
  },

  data() {
    return {
      internalValue: this.modelValue,
      placeholderVal: this.placeholder,
    };
  },

  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },

      set(val) {
        this.$emit('update:modelValue', val);
      },
    },

    computedClasses() {
      return this.disabled ? 'select-disabled' : 'select-active';
    },
  },

  methods: {
    truncateText: UtilsString.truncate,
    getItemText(item) {
      if (['string', 'number', 'boolean'].includes(typeof item)) return item;

      if (typeof this.itemText === 'function') return this.itemText(item);

      return item[this.itemText];
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/input.scss';
@import '@/styles/select.scss';
</style>
